import type { BootstrapStepRow } from '../../devenvbootstrap/framework';

type Props = { items?: BootstrapStepRow[] };

export function BootstrapWorkflowPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.step} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-50 text-xs font-semibold text-brand-700 dark:bg-brand-950 dark:text-brand-300">
                {item.step}
              </span>
              <p className="text-sm font-medium">{item.action}</p>
            </div>
            <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-600 dark:bg-slate-800 dark:text-slate-300">
              {item.status}
            </span>
          </div>
          <p className="mt-1 font-mono text-xs text-slate-500">{item.command}</p>
        </div>
      ))}
    </div>
  );
}
